var _clipPath, _clipPath2, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-95.3204,-2753.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,664.889L27,763.889L99,763.889L99,691.889L72,664.889L27,664.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99,664.889L99,763.889L27,763.889L27,664.889L99,664.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,664.889L99,691.889L99,763.889L27,763.889L27,664.889L72,664.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(136,34,131)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.743,700.963C74.717,701.307 68.64,702.428 62.354,703.555C55.963,704.701 49.475,705.807 42.336,705.079C41.959,703.972 42.092,702.365 41.733,701.242C40.416,701.621 39.103,702.004 38.31,702.916C39.127,708.562 40.118,714.556 40.709,720.385C40.934,722.621 40.902,724.865 41.723,726.14C42.922,728.006 46.84,728.787 50.212,728.559C56.507,728.129 61.761,725.479 67.283,723.391C72.723,721.336 78.7,719.662 86.043,719.727C87.777,719.742 89.482,719.836 91.148,719.998L92.064,700.951C90.373,700.874 88.677,700.835 86.984,700.835C85.229,700.835 83.478,700.877 81.743,700.963ZM82.14,704.158C81.599,703.283 81.887,701.692 83.432,702.254C83.384,702.92 83.562,703.817 83.203,704.168C82.848,704.164 82.494,704.162 82.14,704.158ZM85.971,703.979C85.814,703.176 86.24,702.963 86.199,702.279C86.624,702.283 87.05,702.287 87.476,702.291C87.471,702.859 87.465,703.423 87.459,703.992C86.963,703.989 86.467,703.984 85.971,703.979ZM90.03,702.315C90.455,702.316 90.881,702.323 91.305,702.326C91.256,702.991 91.436,703.887 91.076,704.236C90.83,704.057 90.508,703.951 90.014,704.016C90.019,703.448 90.023,702.881 90.03,702.315ZM78.52,704.338C78.024,703.568 78.242,701.996 79.6,702.433C79.551,703.098 79.73,703.996 79.37,704.346C79.087,704.341 78.802,704.341 78.52,704.338ZM74.472,704.727C74.327,703.436 74.459,702.424 75.979,702.824C75.974,703.393 75.969,703.961 75.965,704.529C75.647,704.477 75.46,704.559 75.274,704.64C75.13,704.704 74.985,704.767 74.779,704.767C74.69,704.767 74.589,704.755 74.472,704.727ZM71.062,705.336C70.736,705.024 70.885,704.244 70.864,703.631C70.998,703.338 71.683,703.607 71.721,703.213C72.584,703.136 71.942,704.541 72.129,705.133C71.806,705.034 71.67,705.127 71.533,705.22C71.439,705.284 71.344,705.348 71.187,705.348C71.15,705.348 71.108,705.344 71.062,705.336ZM40.436,703.359C40.549,703.67 40.177,704.457 40.639,704.426C40.499,704.805 40.171,704.674 39.856,704.544C39.676,704.469 39.498,704.395 39.363,704.414C39.24,703.575 39.848,703.475 40.436,703.359ZM68.308,703.82C69.173,703.747 68.533,705.149 68.719,705.74C68.481,705.698 68.364,705.778 68.247,705.857C68.11,705.949 67.974,706.042 67.652,705.943C67.844,705.097 67.348,704.369 67.67,704.027C67.754,704.033 67.837,704.039 67.915,704.039C68.117,704.039 68.282,704 68.308,703.82ZM64.471,704.64C64.756,704.643 65.039,704.643 65.322,704.646C65.166,705.434 65.678,705.563 65.522,706.349C65.122,706.516 64.737,706.699 64.238,706.766C64.304,706.043 64.091,705.037 64.471,704.64ZM67.217,707.002C72.395,705.762 78.054,705.012 84.262,704.817C84.292,708.711 84.158,712.441 83.947,716.092C83.172,716.02 82.562,716.113 82.031,716.287L80.113,716.482C75.24,716.674 71.491,718.01 67.533,719.137C67.578,714.945 67.382,710.988 67.217,707.002ZM85.539,704.828C87.8,704.803 88.969,704.869 91.066,705.006L90.782,716.375C88.647,716.164 87.404,716.059 85.011,716.1C85.523,712.687 85.04,708.258 85.539,704.828ZM60.206,705.877C61.007,704.789 62.452,705.319 61.897,707.17C61.493,707.4 60.889,707.432 60.403,707.581C60.277,707.072 60.682,706.041 60.206,705.877ZM55.5,708.389C55.507,707.75 55.511,707.113 55.516,706.474C55.939,706.186 56.735,706.281 57.223,706.065C57.596,706.469 57.366,707.471 57.418,708.193C56.844,708.195 56.496,708.428 55.921,708.428C55.794,708.428 55.655,708.417 55.5,708.389ZM51.044,706.965C51.273,706.877 51.503,706.788 51.897,706.865C51.762,707.771 52.037,708.273 52.087,708.996C51.701,708.903 51.493,708.993 51.286,709.084C51.1,709.166 50.914,709.247 50.598,709.195C50.228,708.713 50.511,707.596 50.191,707.065C50.298,707.086 50.392,707.095 50.478,707.095C50.709,707.095 50.877,707.03 51.044,706.965ZM42.725,709.125C42.217,708.853 42.857,707.449 42.318,707.207C42.336,706.913 42.689,706.955 43.041,706.998C43.249,707.023 43.456,707.049 43.596,707.004C43.438,707.932 43.945,708.207 43.79,709.135C43.436,709.131 43.08,709.129 42.725,709.125ZM65.938,707.205C66.732,710.784 66.19,715.676 66.677,719.555C60.539,721.323 55.449,724.157 47.487,724.065C46.993,719.623 46.197,714.367 46.121,710.218C46.577,710.231 47.027,710.237 47.47,710.237C54.618,710.237 60.189,708.632 65.938,707.205ZM46.553,709.372C46.27,708.811 46.315,707.92 46.148,707.24C46.643,707.246 47.138,707.25 47.636,707.254C47.402,708.192 48.042,708.903 47.617,709.381C47.264,709.379 46.908,709.377 46.553,709.372ZM39.743,709.312C40.837,709.365 42.64,710.541 44.843,710.209C45.336,715.16 45.77,719.096 46.422,724.055C44.709,723.91 43.367,723.401 42.177,722.74C42.387,721.737 43.385,721.535 44.107,721.054C44.115,719.641 43.666,718.678 43.717,717.22C42.666,717.439 42.095,718.146 41.361,718.689C40.734,718.5 41.859,718.375 41.582,717.84C41.375,717.844 41.418,718.098 41.368,718.264C40.894,718.176 41.174,716.933 41.585,717.627C41.491,717.437 41.402,717.244 41.164,717.199L40.964,715.494C41.086,714.398 41.238,714.935 40.549,714.638C40.928,714.241 40.715,713.234 40.78,712.513C40.572,712.518 40.613,712.772 40.564,712.937C40.361,711.797 40.627,710.16 39.743,709.312ZM85.626,718.66C85.631,718.093 85.637,717.525 85.642,716.959C86.069,716.963 86.495,716.965 86.92,716.971C86.889,717.582 87.023,718.363 86.69,718.67C86.336,718.666 85.982,718.662 85.626,718.66ZM81.584,718.624C81.588,718.2 81.59,717.773 81.594,717.347C81.873,717.057 82.522,717.145 83.086,717.148C83.083,717.644 83.077,718.14 83.073,718.639C82.727,718.551 82.463,718.615 82.247,718.678C82.106,718.718 81.985,718.759 81.873,718.759C81.771,718.759 81.677,718.725 81.584,718.624ZM89.244,718.691C89.248,718.195 89.254,717.701 89.258,717.203L90.536,717.215C90.529,717.711 90.526,718.209 90.521,718.703C90.094,718.701 89.67,718.697 89.244,718.691ZM78.176,719.02C78.178,718.594 78.183,718.166 78.188,717.744C78.321,717.449 79.007,717.717 79.041,717.324C79.69,717.347 79.528,718.721 79.241,719.029C78.885,719.026 78.529,719.021 78.176,719.02ZM75.418,717.93C76.26,717.809 75.659,719.101 75.827,719.637C75.747,719.641 75.659,719.636 75.57,719.632C75.29,719.617 75.008,719.602 74.975,719.839C74.315,719.787 74.625,718.777 74.567,718.137C74.647,718.133 74.736,718.137 74.824,718.142C74.889,718.145 74.954,718.148 75.016,718.148C75.222,718.148 75.394,718.114 75.418,717.93ZM71.138,720.658C71.142,720.163 71.147,719.666 71.15,719.168C71.285,718.875 71.97,719.146 72.006,718.75C72.847,718.629 72.246,719.922 72.417,720.457C72.091,720.376 71.933,720.467 71.777,720.558C71.662,720.624 71.548,720.689 71.369,720.689C71.302,720.689 71.226,720.68 71.138,720.658ZM41.998,719.119C43.034,719.724 42.419,720.998 41.763,721.459C41.184,720.754 41.299,719.562 41.998,719.119ZM67.949,720.205C68.387,720.055 68.797,719.543 69.229,720.004C69.379,721.088 69.058,721.69 68.148,721.697C68.326,720.959 67.839,720.875 67.949,720.205ZM64.948,722.943C64.996,722.279 64.816,721.383 65.176,721.031C65.46,721.033 65.744,721.037 66.028,721.039C66.146,722.141 65.972,722.945 65.01,722.945C64.99,722.945 64.969,722.944 64.948,722.943ZM61.332,722.486C61.465,722.194 62.15,722.461 62.186,722.069C63.129,721.777 62.178,723.34 62.816,723.349C62.623,723.942 61.953,724.047 61.317,724.189C61.322,723.621 61.326,723.052 61.332,722.486ZM41.535,723.371C42.637,723.344 42.428,724.603 42.793,725.299C42.618,725.434 42.472,725.493 42.349,725.493C41.723,725.493 41.691,723.986 41.535,723.371ZM56.836,725.639C56.717,725.264 57.103,724.391 56.635,724.359C56.918,723.717 57.641,723.521 58.557,723.526C58.553,724.092 58.548,724.66 58.543,725.229C58.076,725.392 57.704,725.651 57.075,725.651C56.999,725.651 56.92,725.647 56.836,725.639ZM51.947,724.957C52.447,724.89 52.748,724.625 53.439,724.758C53.246,725.604 53.743,726.332 53.422,726.672C53.308,726.715 53.129,726.69 52.949,726.666C52.642,726.624 52.335,726.582 52.356,726.873C51.815,726.633 51.949,725.728 51.947,724.957ZM44.5,724.888C45.151,724.74 45.274,725.113 45.776,725.113C45.77,725.681 45.764,726.248 45.759,726.814C45.65,726.831 45.551,726.839 45.459,726.839C44.477,726.839 44.452,725.9 44.5,724.888ZM48.313,727.048C48.307,726.35 47.961,725.99 48.115,725.133C48.541,725.139 48.965,725.14 49.393,725.147C49.271,725.968 49.762,726.187 49.588,727.063C49.16,727.058 48.736,727.055 48.313,727.048Z",
    style: {
      fill: "url(#_Linear3)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,691.889L99,691.889L72,664.889L72,691.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5,678.389L72,664.889L99,691.889L85.5,705.389L58.5,678.389Z",
    style: {
      fill: "url(#_Linear5)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,664.889L99,691.889L72,691.889L72,664.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(136,34,131)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6,1.13687e-13)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "34px",
    y: "755.89px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "white"
    }
  }, "A", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "52.143px 70.818px ",
    y: "755.89px 755.89px "
  }, "VI")))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,99,-99,-4.3e-06,63,664.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(226,205,228)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "93%",
    style: {
      stopColor: "rgb(156,67,152)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(147,41,143)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(53.7529,0,0,53.7529,38.3105,714.717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(150,51,146)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(111,18,107)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.5003,-13.5003,13.5003,13.5003,72.0005,691.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(250,240,246)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    style: {
      stopColor: "rgb(222,196,222)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    style: {
      stopColor: "rgb(178,117,176)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(147,41,143)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/avi.5241c7a95ef97e2710876b2c889e0356.svg";
export { ForwardRef as ReactComponent };